"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeepCompareEffectNoCheck = exports.useDeepCompareEffect = void 0;

var deep_equals_1 = require("./deep-equals");

var react_1 = require("react");

function checkDeps(deps) {
  if (!deps || !deps.length) {
    throw new Error('useDeepCompareEffect should not be used with no dependencies. Use useEffect instead.');
  }

  if (deps.every(isPrimitive)) {
    throw new Error('useDeepCompareEffect should not be used with dependencies that are all primitive values. Use useEffect instead.');
  }
}

function isPrimitive(val) {
  return val == null || /^[sbn]/.test(typeof val);
}

function useDeepCompareMemoize(value) {
  var ref = (0, react_1.useRef)();
  var signalRef = (0, react_1.useRef)(0);

  if (!(0, deep_equals_1.deepEquals)(value, ref.current)) {
    ref.current = value;
    signalRef.current += 1;
  }

  return [signalRef.current];
}

function useDeepCompareEffect(callback, dependencies) {
  if (process.env.NODE_ENV !== 'production') {
    checkDeps(dependencies);
  }

  return (0, react_1.useEffect)(callback, useDeepCompareMemoize(dependencies));
}

exports.useDeepCompareEffect = useDeepCompareEffect;

function useDeepCompareEffectNoCheck(callback, dependencies) {
  return (0, react_1.useEffect)(callback, useDeepCompareMemoize(dependencies));
}

exports.useDeepCompareEffectNoCheck = useDeepCompareEffectNoCheck;